export const EMOTIONAL_STATE_LABELS = {
  calm: "Calm",
  anxious: "Anxious",
  excited: "Excited",
  fearful: "Fearful",
  revenge: "Revenge",
};

export const formatEmotionalState = (value) =>
  EMOTIONAL_STATE_LABELS[value] || value || "";
